import { userInfoLoader } from "../../loaders/user/userInfoLoader";
import { setCookie } from "@/utils/cookie";

/** Кейсы загрузки информации о пользователе */
export const userInfoCases = (builder: any) => {
    builder
        .addCase(userInfoLoader.pending, (state: any) => {
            state.loading.userInfo = true;
        })
        .addCase(userInfoLoader.fulfilled, (state: any, action: any) => {
            setCookie('guestId', action.payload.guestId);
            state.userInfo = action.payload;
            state.loading.userInfo = false;
        })
        .addCase(userInfoLoader.rejected, (state: any, action: any) => {
            state.error.userInfo = action.payload;
            state.loading.userInfo = false;
        });

    return builder;
}